import { render } from "./ProjectBumperDisplaySection.vue?vue&type=template&id=61a7e5f0&scoped=true"
import script from "./ProjectBumperDisplaySection.vue?vue&type=script&lang=js"
export * from "./ProjectBumperDisplaySection.vue?vue&type=script&lang=js"

import "./ProjectBumperDisplaySection.vue?vue&type=style&index=0&id=61a7e5f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a7e5f0"]])

export default __exports__